import * as React from 'react';
import { getCurrencyFormat } from '../../helpers/currency-format';
interface IStateProps {    
    packageTotalPriceInCart: number;
    packageFeeAmountInCart: number;
    packageSeatAmountInCart: number;
    packageTotalCount: number;
    currentItemIndex: number;
    packageProgressMessage: string;
    venueName: string;
    showPackageProgressBar: boolean;
    showComponent: boolean;
    seatQuantityText: string;
    flexInstructions: string;
    currencyFormat: string;
    packagePriceText: string;
    selectedQuantity: number;
    feeAmountText: string;
    ticketCostText: string;
    priceFeeHeading: string;
    displaySeatFee: boolean;
    partialPackageTotalsLabel: string;
    cartSeats: Array<CartSeat>;
}

class PackagesProgressHeader extends React.Component<IStateProps, any>{    
    constructor(props) {
        super(props);        
    }

    get cartFeeTotal(): number {
        return this.props.cartSeats.map(seat => seat.selectedPricing.feeAmount).reduce((sum, n) => sum + n, 0)
            + this.props.packageFeeAmountInCart;
    }
    get cartSeatTotal(): number {

        return this.props.cartSeats.map(seat => seat.selectedPricing.priceCarted).reduce((sum, n) => sum + n, 0)
            + this.props.packageSeatAmountInCart;
    }

    get cartSubTotal(): number {
        if (this.props.displaySeatFee)
            return this.cartFeeTotal + this.cartSeatTotal;
        return this.cartSeatTotal;
    }

    getFeeDisplay() {
        return (
            <>            
                {this.cartFeeTotal > 0 ?
                    <>
                    <p className="caption-paragraph">{this.props.priceFeeHeading}</p>                                                        
                    {
                            this.cartSeatTotal > 0 ?
                            <p className="caption-paragraph"><strong>{this.props.ticketCostText}</strong> {getCurrencyFormat(this.props.currencyFormat, this.cartSeatTotal)}</p>
                        : null
                    }
                    {
                            this.cartFeeTotal > 0 ?
                            <p className="caption-paragraph"><strong>{this.props.feeAmountText}</strong> {getCurrencyFormat(this.props.currencyFormat, this.cartFeeTotal)}</p>
                        : null
                        }
                    </> : null
                }
            </>
        );
    }

    render() {
        if (!this.props.showComponent)
            return null;

        var progressBar = [];
        for (var i = 1; i <= this.props.packageTotalCount; i++) {
            var className = "packages-progress-unreserved";
            if (i < this.props.currentItemIndex) {
                className = "packages-progress-reserved";
            }
            else if (i == this.props.currentItemIndex) {
                className = "packages-progress-active";
            }

            const classes = `${className} packages-progress-item`;

            progressBar.push(<span key={i} className={classes}>{i}</span>)
        }

        return (
            <section className="filters-section packages-progress-section">
                <div className="packages-progress-section-inner">
                    <div>
                        <div className="packages-progress-section-heading">
                            <p className="caption-paragraph"><strong>{this.props.packageProgressMessage}</strong></p>
                            <p className="caption-paragraph"><strong>{this.props.venueName}</strong></p>
                        </div>
                        {
                            this.props.showPackageProgressBar ?
                                <div className="packages-progress-container">{progressBar}</div>
                                : null
                        }

                        <p className="packages-progress-instructions">{this.props.flexInstructions}</p>
                    </div>
                </div>
                <div className="packages-progress-total-container">
                    <div className="packages-progress-section-inner">
                        <p className="caption-paragraph"><strong>{this.props.seatQuantityText}</strong> {this.props.selectedQuantity.toString()}</p>
                        <p className="caption-paragraph">
                            <h3>{this.props.partialPackageTotalsLabel}: {getCurrencyFormat(this.props.currencyFormat, this.cartSubTotal)}</h3>
                             {this.props.displaySeatFee ? this.getFeeDisplay() : null}
                        </p>
                    </div>
                </div>
            </section>
        );
    }
}

export default PackagesProgressHeader;